module.exports = __webpack_public_path__ + "img/loading-fonts5.141d6b8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/loading-fonts5.svg
// module id = ./assets/loading/loading-fonts5.svg
// module chunks = 2 3 4 5 6 7 8